'use strict'

const hosts = {
  user: 'https://qa5-user.hanatour.com',
  userMobile: 'https://qa5-user-mobile.hanatour.com',
  seller: 'https://qa-seller.hanatour.com',
  hanatour: 'https://qatour5.hanatour.com',
  hanatourAccount: 'https://qa-accounts.hanatour.com',
  hanatourApi: 'https://qaapi.hanatour.com',
  hanatourGw: 'https://qa-gw.hanatour.com',
  hanatourImg: 'https://qaimage.hanatour.com',
  fndStatic: 'https://dev-static.hanatour.com',
  hatsApi: 'https://qa-hats.hanatour.com',
  hanatourPay: 'https://qa-pay5.hanatour.com',
}

// 외부 API
const externalApi = {
  googleMap: {
    key: 'AIzaSyAKlC9AdN5hLaRGU83cbsaBQw8Y6EeDBC0',
  },
  googleAnalytic: {
    key: '',
  },
}

module.exports = {
  hosts,
  externalApi,
  deployEnv: 'qa5',
  axiosTimeout: 30000,
  gtxSellerIds: ['MHJ-S230405001'], // 글로벌틱스 seller id (환경 내에서도 계정이 여러개일 수 있다)
  jtrSellerIds: ['MHJ-S220623001', 'MHJ-S220811001'], // JTR seller id
  grlSellerIds: ['MHJ-U23090400000001', 'MHJ-S230904001'],
  rakutenGoraSellerIds: ['MHJ-S250507001'],
  kkdaySellerIds: ['MHJ-S250514001'], // kkday seller id
}
